export default __webpack_public_path__ + "static/media/115.e0682131.jpg";